var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"before-close":_vm.closeModal,"title":"錯誤","width":"700px"}},[_c('enhanced-table',{attrs:{"table-data":_vm.showList,"col-configs":_vm.colConfigs,"show-search":false,"sortable":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }